import React from 'react';
import Spotlight from './Spotlight';
import './Workflows.css';

const Workflows: React.FC = () => {
  const workflows = [
    {
      image: '/images/workflow-01.png',
      label: 'Build Your Model',
      description: 'Use our drag-and-drop model builder to create neural network architectures. Choose from CNN, Transformer, MLP, RNN, and more. Visualize tensor shapes and connections in real-time.'
    },
    {
      image: '/images/workflow-02.png',
      label: 'Train & Monitor',
      description: 'Train your models with real-time visualization. Watch activations flow through layers in 3D, monitor loss and accuracy metrics, and gain insights into network behavior during training.'
    },
    {
      image: '/images/workflow-03.png',
      label: 'Deploy & Run',
      description: 'Deploy your trained models via our RESTful API. Run inference on new data, manage multiple models, and integrate seamlessly with your applications.'
    }
  ];

  return (
    <section className="workflows-section">
      <div className="workflows-container">
        <div className="workflows-content">
          <div className="workflows-header">
            <div className="workflows-label">Your ML Workflow</div>
            <h2 className="workflows-title">From concept to deployment</h2>
            <p className="workflows-subtitle">
              Build, train, and deploy neural networks with an intuitive interface designed for ML practitioners. 
              Seamlessly integrate with PyTorch and streamline your entire machine learning pipeline.
            </p>
          </div>
          <Spotlight className="workflows-grid">
            {workflows.map((workflow, index) => (
              <a key={index} href="#0" className="workflow-card">
                <div className="workflow-card-inner">
                  <div className="workflow-arrow" aria-hidden="true">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="9"
                      height="8"
                      fill="none"
                    >
                      <path
                        fill="#F4F4F5"
                        d="m4.92 8-.787-.763 2.733-2.68H0V3.443h6.866L4.133.767 4.92 0 9 4 4.92 8Z"
                      />
                    </svg>
                  </div>
                  <img
                    src={workflow.image}
                    alt={workflow.label}
                    className="workflow-image"
                  />
                  <div className="workflow-content">
                    <div className="workflow-label-wrapper">
                      <span className="workflow-label">{workflow.label}</span>
                    </div>
                    <p className="workflow-description">{workflow.description}</p>
                  </div>
                </div>
              </a>
            ))}
          </Spotlight>
        </div>
      </div>
    </section>
  );
};

export default Workflows;

